import { MEDIA_QUERY_KEY } from '@/queries/use-media';
import { useMediaStatusEvents } from '@/queries/use-media-status-events';
import { updateItemOnQueriesData } from '@/utils/update-query-data';
import type { Media as RosMedia } from '@carvia/ros-client-types';
import { useQueryClient } from '@tanstack/vue-query';
import { type MaybeRefOrGetter, ref, toRef, watch } from 'vue';

export function useMediaListStatusSync(enabled: MaybeRefOrGetter<boolean> = true) {
  const queryClient = useQueryClient();
  const { events } = useMediaStatusEvents(toRef(enabled));
  const processedEventsCount = ref(0);

  watch(
    events,
    (newEvents) => {
      if (newEvents.length <= processedEventsCount.value) {
        return;
      }

      const newUnprocessedEvents = newEvents.slice(processedEventsCount.value);
      newUnprocessedEvents.forEach((event) => {
        updateItemOnQueriesData<RosMedia>([MEDIA_QUERY_KEY], event.media, queryClient);
      });
      processedEventsCount.value = newEvents.length;
    },
    { deep: true },
  );
}
